import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SelectO } from "../../components";
import AHeader from "./aHeader";
import DHeader from "./dHeader";
import PHeader from "./pHeader";
import { PiUser } from "react-icons/pi";
import { actionCommon } from "../../redux/actions";

const Header = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [options, setOptions] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState(null);
    const { i18n } = useTranslation();

    useEffect(() => {
        dispatch(actionCommon.getLanguages());
    }, [dispatch]);

    const getLanguagesData = useSelector(
        (state) => state.common.getLanguagesData?.data
    );

    useEffect(() => {
        if (getLanguagesData) {
            const newOptions = getLanguagesData.result
                .filter((item) => item.isWebsiteLanguage)
                .map((item) => ({
                    value: item.languageId,
                    label: item.languageName,
                    abb: item.languageAbbreviation,
                }));

            setOptions(newOptions);

            const storedLang = localStorage.getItem("i18nextLng");
            const defaultLang =
                newOptions.find((lang) => lang.abb === storedLang) || newOptions[0];

            if (defaultLang) {
                setSelectedLanguages(defaultLang);
                i18n.changeLanguage(defaultLang.abb);
            }
        }
    }, [getLanguagesData, i18n]);

    const handleSelectChange = (selected) => {
        setSelectedLanguages(selected);
        i18n.changeLanguage(selected.abb);
    };

    const propsCompo = {
        component1: (
            <SelectO.SelectO
                options={options}
                onChange={handleSelectChange}
                className="select0"
                isSearchable={false}
                value={selectedLanguages}
                formatOptionLabel={(option, { context }) =>
                    context === "value" ? option.label.slice(0, 3) : option.label
                }
            />
        ),
    };

    const handlePath = (path) => {
        navigate(path);
    };

    const props = {
        languageSelect: propsCompo.component1,
        icon: <PiUser className="piuser" />,
        handlePath,
    };

    const renderHeader = () => {
        const pathsToShowHeader = [
            "/",
            `/book-an-appointment`,
            `/book-an-appointment/specialist-list`,
            `/book-an-appointment/clinics-list`,
            "/chat-with-specialist",
            "/emergency",
            "/doctor/terms-and-conditions",
            "/doctor/privacy-policy",
            "/patient",
            "/doctor",
            "/admin",
        ];

        if (pathsToShowHeader.includes(location.pathname)) {
            switch (location.pathname) {
                case "/admin":
                    return <AHeader />;
                case "/doctor":
                case "/doctor/how-its-works":
                case "/doctor/payment-plan":
                case "/doctor/team":
                case "/doctor/contact":
                case "/doctor/privacy-policy":
                case "/doctor/terms-and-conditions":
                    return <DHeader {...props} />;
                default:
                    return <PHeader {...props} />;
            }
        }
        return null;
    };

    return <>{renderHeader()}</>;
};

export default Header;
